import React from 'react';
import {
  getTaxRateToUpdateMessage,
  getUnapprovedEntryMessage,
} from './helpers';

const ConfirmationDialogContent = ({ dialogData }: {
  dialogData: {
    shouldWarnAboutBatchUpdate: boolean,
    shouldWarnAboutCurrencyEdit: boolean,
    shouldWarnAboutSecondaryCurrencyEdit: boolean,
    shouldWarnAboutBSMBalances: boolean,
    shouldWarnAboutDisablingRelatedUSObligation: boolean,
    changedRow: {
      companyCode: string,
    },
    taxRatesToUpdate: number,
    unapprovedEntryCount: number,
  },
}) => {
  const {
    shouldWarnAboutBatchUpdate,
    shouldWarnAboutCurrencyEdit,
    shouldWarnAboutSecondaryCurrencyEdit,
    shouldWarnAboutBSMBalances,
    shouldWarnAboutDisablingRelatedUSObligation,
    changedRow,
    taxRatesToUpdate,
    unapprovedEntryCount,
  } = dialogData;
  return (
    <div>
      {
        shouldWarnAboutBatchUpdate
          ? <div>Update will be applied to all rows for company code: {changedRow && changedRow.companyCode}</div>
          : null
      }
      {
        shouldWarnAboutCurrencyEdit
          ? (
            <div>
              You are changing tax currency for a BSM Enabled Company Code.
              All existing BSM balances must be cleared prior to changing tax currency.
              Only click &quot;Save&quot; if you confirm there are no existing BSM Balances
            </div>
          )
          : null
      }
      {
        shouldWarnAboutSecondaryCurrencyEdit
          ? (
            <div>
              Warning! To properly clear the US balances, edit all associated US tax rates to 0% and
              complete a successful calculation prior to making this change to Secondary Tax,
              or disable the US Obligations instead.
              Only click &quot;Save&quot; if you confirm there are no existing BSM Balances
            </div>
          )
          : null
      }
      {
        shouldWarnAboutBSMBalances
          ? (
            <div className="mt-2">
              Warning! You are disabling obligations for a BSM enabled company code.
              This may orphan balances.
              Only click &quot;Save&quot; if you confirm there are no existing BSM Balances, or they have been cleared.
            </div>
          )
          : null
      }
      {
        shouldWarnAboutDisablingRelatedUSObligation
          ? (
            <div className="mt-2">
              You are clearing Secondary Tax for BSM enabled company code:
              All US Obligations will be disabled
            </div>
          )
          : null
      }
      {
        taxRatesToUpdate > 0
          ? (
            <div className="mt-2">
              { getTaxRateToUpdateMessage(taxRatesToUpdate) }
            </div>
          )
          : null
      }
      {
        unapprovedEntryCount > 0
          ? (
            <div className="mt-2">
              { getUnapprovedEntryMessage(unapprovedEntryCount) }
            </div>
          )
          : null
      }
    </div>
  );
};

export default ConfirmationDialogContent;
